import { render, staticRenderFns } from "./DashboardV1.vue?vue&type=template&id=704f8318&scoped=true"
import script from "./DashboardV1.vue?vue&type=script&lang=js"
export * from "./DashboardV1.vue?vue&type=script&lang=js"
import style0 from "./DashboardV1.vue?vue&type=style&index=0&id=704f8318&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f8318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704f8318')) {
      api.createRecord('704f8318', component.options)
    } else {
      api.reload('704f8318', component.options)
    }
    module.hot.accept("./DashboardV1.vue?vue&type=template&id=704f8318&scoped=true", function () {
      api.rerender('704f8318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboardviews/DashboardV1.vue"
export default component.exports